import type { FaireProductEntity } from "../../entity_types/product";

export const p_mw9dtyqyvm: FaireProductEntity = {
  token: "p_mw9dtyqyvm",
  type: "product",
  name: "christmas watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/737a3e6a6c4207331d3edfccd953677b1b0c77596e3798f5eb6839f009a98e6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d98695486662d33e0a30057829e5fe3d43bc5599c10d075570d2ad04b33dd0dc.jpeg",
    "https://cdn.faire.com/fastly/75cd6c2b92db7b53076cac63deaae16b245b8e1d1672a6947823cf9fed69918c.jpeg",
    "https://cdn.faire.com/fastly/4cb3dd93640ebdb73256c149fd4e618b167eed65e8e6e872321c54574bf75a84.jpeg",
    "https://cdn.faire.com/fastly/c4c09520ac6587c960a76cb17a2c1a19dc4fee1e0ec00aae3b6667a7b81186f2.jpeg",
    "https://cdn.faire.com/fastly/1ef26402757820a7104f483c158413fccebf6f65965c79a732000ca2ff9cef91.jpeg",
    "https://cdn.faire.com/fastly/ca8552a58aa9eee1b113862b343142586261bffd759656ed07d578a32ea9a409.jpeg",
    "https://cdn.faire.com/fastly/423251296bf976348079f6afcbbda3cbe1582647b6298f0e675729ebcd1c2ac7.jpeg",
    "https://cdn.faire.com/fastly/ed624a3bbfb9a9f44c5e17eca0ba4a10c3a8b9ea479fc4b9fb900dac89c144b3.jpeg",
  ],
  priceDollars: 17,
  description:
    "The idea for the Watercolor Workbooks started with kids in mind. Simple outlined sketches they could paint with watercolors just like with crayons in a coloring book.\n\nWhat was surprising was how many grown-ups took to the books! Grandmothers painting with grandkids, girlfriends gathering together, young moms painting in their books during naptime, first-time artists who needed something less intimidating than a blank page.\n\nWatercolor Workbooks provide just the right amount of instructions and relaxing fun to encourage you and the kids to pick up a paintbrush to start watercoloring today.\n",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:00.672Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
